import React, { Suspense } from "react";

import Loading from "./Loading";

const WithSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default WithSuspense;
